var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { style: _vm.style, attrs: { id: _vm.chunkId } },
    [
      _vm.show
        ? [
            _vm._l(_vm.items, function (item) {
              return _vm._t("default", null, { item: item })
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }